/**
 * S2 (AB#2205, SG-17) — "Staff · Glamour Palace" under the name in the account
 * menu. Rendered only for staff sessions (owners never see it).
 */
import React from 'react';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { useStaffMe } from '../../../../hooks/useStaffSelf';
import { staffIdentityLine } from '../../../../lib/staffDisplay';
import styles from './menu.module.css';

const StaffMenuIdentity: React.FC = () => {
    const { t, language } = useLanguage();
    const { data } = useStaffMe();
    const line = staffIdentityLine(data, language, t);
    if (!line) return null;
    return <div className={styles.profileRole} data-testid="staff-menu-identity">{line}</div>;
};

export default StaffMenuIdentity;
